module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cabecalho-da-solicitacao"
  }, [_c('div', {
    staticClass: "cabecalho-da-solicitacao__linha"
  }, [_c('div', {
    staticClass: "cabecalho-da-solicitacao__identificacao"
  }, [_c('span', {
    staticClass: "titulo titulo_mini cabecalho-da-solicitacao__rotulo"
  }, [_vm._v("\n        Subsídio da AGEHAB\n      ")]), _vm._v(" "), _c('span', {
    staticClass: "titulo titulo_grande cabecalho-da-solicitacao__titular"
  }, [_vm._v("\n        " + _vm._s(_vm.nomeDoTitular) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "no-print cabecalho-da-solicitacao__acoes"
  }, [_vm._l((_vm.acoesDaSituacao), function(acao) {
    return [(acao.impedida) ? _c('span', {
      key: acao.chave + '-impedida',
      staticClass: "dica"
    }, [_c('button', {
      staticClass: "botao botao_medio botao_cor-primaria botao_com-icone-para-esquerda",
      attrs: {
        "type": "button",
        "disabled": ""
      }
    }, [_c('i', {
      class: acao.icone,
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("\n            " + _vm._s(acao.rotulo) + "\n          ")]), _vm._v(" "), _c('span', {
      staticClass: "dica__conteudo dica__conteudo_inferior dica__conteudo_medio"
    }, [_vm._v("\n            " + _vm._s(acao.impedimento.mensagem) + "\n          ")])]) : _c('button', {
      key: acao.chave + '-disponivel',
      staticClass: "botao botao_medio botao_cor-primaria botao_com-icone-para-esquerda",
      class: {
        botao_contorno: !acao.destaque
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.$emit('executar-acao', acao)
        }
      }
    }, [_c('i', {
      class: acao.icone,
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("\n          " + _vm._s(acao.rotulo) + "\n        ")])]
  }), _vm._v(" "), (_vm.podeAutorizarPagamento) ? _c('button', {
    staticClass: "no-print botao botao_medio botao_cor-primaria botao_com-icone-para-esquerda",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('abrir-pagamento')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-dollar-sign",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n        Liquidar\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dropdown dropdown_direita"
  }, [_c('button', {
    staticClass: "botao botao_medio botao_icone botao_sem-preenchimento cabecalho-da-solicitacao__mais-acoes",
    class: {
      'cabecalho-da-solicitacao__mais-acoes_destacado': _vm.acoesDaSituacao.length === 0,
    },
    attrs: {
      "type": "button",
      "aria-haspopup": "true",
      "aria-label": "Mais ações"
    }
  }, [_c('i', {
    staticClass: "fas fa-ellipsis-h",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown__lista",
    attrs: {
      "aria-label": "Submenu"
    }
  }, [(_vm.podeEditar) ? _c('li', {
    staticClass: "dropdown__item"
  }, [_c('button', {
    staticClass: "dropdown__link",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('editar')
      }
    }
  }, [_c('i', {
    staticClass: "far fa-pencil dropdown__icone",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n              Editar\n            ")])]) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.podeAlterarNup) ? _c('li', {
    staticClass: "dropdown__item"
  }, [_c('button', {
    staticClass: "dropdown__link",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('abrir-alteracao-nup')
      }
    }
  }, [_c('i', {
    staticClass: "far fa-pencil-alt dropdown__icone",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n              Alterar NUP\n            ")])]) : _vm._e()])])], 2)]), _vm._v(" "), _c('span', {
    staticClass: "titulo titulo_medio titulo_cor-primaria cabecalho-da-solicitacao__valor"
  }, [_vm._v("\n    " + _vm._s(_vm.subsidioDaAgehab) + "\n  ")]), _vm._v(" "), (_vm.solicitacaoEhDoBonusMoradia) ? _c('linha-do-tempo-da-solicitacao', {
    attrs: {
      "linha-do-tempo": _vm.linhaDoTempo
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "dropdown__item"
  }, [_c('button', {
    staticClass: "dropdown__link",
    attrs: {
      "type": "button",
      "onclick": "window.print()"
    }
  }, [_c('i', {
    staticClass: "far fa-print dropdown__icone",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n              Imprimir resumo\n            ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ca4ff70"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/controle-de-solicitacoes/detalhes-da-solicitacao/components/CabecalhoDaSolicitacao.vue
// module id = 1102
// module chunks = 1